import { index, pgTable, text } from 'drizzle-orm/pg-core'
import { getTimestampWithTimezone, typedJsonb } from '../common/utils'

/**
 * Generic cache table for expensive operations
 * Uses text primary key for flexibility (supports composite keys like "duration:coord1:coord2")
 */
export const cache = pgTable(
  'cache',
  {
    key: text('key').primaryKey(),
    value: typedJsonb('value').notNull(),
    expiresAt: getTimestampWithTimezone().notNull(),
  },
  (table) => [index('cache_expires_at_idx').on(table.expiresAt)],
)
